import React from "react";
import { Box, Checkbox, LinkButton, Typography } from "@bca/ui-library";

interface TermsAndConditionsProps {
  termsAndConditionsLink: string | null;
  checked: boolean;
  setChecked: (newValue: any) => void;
}

const TermsAndConditions: React.FunctionComponent<TermsAndConditionsProps> = ({
  termsAndConditionsLink,
  checked,
  setChecked,
}) => {
  return (
    <>
      <Box display="flex" mt={6}>
        <Typography variant="body" color="grey-blue" m={0}>
          To participate in online sales please read and accept the
          <LinkButton
            variant="tertiary"
            text="terms and conditions."
            fontSize={14}
            shouldOpenInNewWindow
            link={termsAndConditionsLink}
            m={0}
            ml={1}
            p={0}
            height="auto"
          />
        </Typography>
      </Box>
      <Box
        mt={3}
        css={`
          & span {
            color: #64798c;
          }
        `}
      >
        <Checkbox
          label="I have read and accept the terms & conditions"
          id="terms-and-conditions"
          checked={checked}
          onChange={() => {
            setChecked(!checked);
          }}
        />
      </Box>
    </>
  );
};

export default TermsAndConditions;
